import {
  createContext,
  FC,
  PropsWithChildren,
  RefObject,
  useContext,
  useRef,
} from 'react';

export type RefsContext = {
  headingRef: RefObject<HTMLDivElement | null>;
  headerRightRef: RefObject<HTMLDivElement | null>;
  headerRef: RefObject<HTMLDivElement | null>;
  contentAreaRef: RefObject<HTMLDivElement | null>;
  mainRef: RefObject<HTMLDivElement | null>;
  layoutRef: RefObject<HTMLDivElement | null>;
  profileInfoRef: RefObject<HTMLDivElement | null>;
  orgSwitcherRef: RefObject<HTMLDivElement | null>;
};

export const refsContext = createContext<RefsContext | null>(null);

export const RefsProvider: FC<PropsWithChildren> = ({ children }) => {
  const headingRef = useRef<HTMLDivElement>(null);
  const headerRightRef = useRef<HTMLDivElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);
  const contentAreaRef = useRef<HTMLDivElement>(null);
  const mainRef = useRef<HTMLDivElement>(null);
  const layoutRef = useRef<HTMLDivElement>(null);
  const profileInfoRef = useRef<HTMLDivElement>(null);
  const orgSwitcherRef = useRef<HTMLDivElement>(null);

  return (
    <refsContext.Provider
      value={{
        headerRef,
        headingRef,
        headerRightRef,
        contentAreaRef,
        mainRef,
        layoutRef,
        profileInfoRef,
        orgSwitcherRef,
      }}
    >
      {children}
    </refsContext.Provider>
  );
};

export const useLayoutRefs = () => {
  const context = useContext(refsContext);
  if (!context) {
    throw new Error('use layout refs provider');
  }
  return context;
};
